'use client'

import { useEffect, useRef } from 'react'

const speedTestScripts = [
  { id: 'speedtest', src: '/speedtest.js' },
  { id: 'speedtestworker', src: '/speedtest_worker.js' }
]

/**
 * Loads the legacy speed-test runtime once for the whole application.
 * The component is mounted only when the speed-test feature is enabled.
 */
export default function SpeedTestScriptLoader () {
  const initialRender = useRef(true)

  useEffect(() => {
    if (!initialRender.current) return
    initialRender.current = false

    speedTestScripts.forEach(({ id, src }) => {
      // Checking both id and src makes this safe if another host already added the script.
      if (document.getElementById(id) || document.querySelector(`script[src="${src}"]`)) return

      const script = document.createElement('script')
      script.id = id
      script.type = 'text/javascript'
      script.src = src
      script.async = true
      document.body.appendChild(script)
    })
  }, [])

  return null
}
